import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import VectorDBCube from "./VectorDBCube";
import { cn } from "../../lib/utils";
import { VectorDBVisualizationProps } from "@/types/components";

const VectorDBVisualization: React.FC<VectorDBVisualizationProps> = ({ 
  className, 
  canvaStyles 
}) => {
  return (
    <div className={cn("absolute inset-0 z-0", className)}>
      <Canvas camera={{ position: [0, 0, 5] }} style={canvaStyles}>
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} />
        <Suspense fallback={null}>
          <VectorDBCube />
        </Suspense>
        <OrbitControls enableZoom={false} enablePan={false} />
      </Canvas>
    </div>
  );
};

export default VectorDBVisualization;
